import { jsxs, jsx } from "react/jsx-runtime";
import { Box, Text, List, Anchor, TextButton, ButtonGroup, IconButton, IconFacebook, IconInstagram, IconLinkedIn, IconX } from "@zillow/constellation";
const B2BFooter = ({
  logo,
  columns = [],
  disabled
}) => {
  const showCookieConsentBanner = () => {
    var _a, _b;
    (_b = (_a = window.DG_BANNER_API) == null ? void 0 : _a.showLayer) == null ? void 0 : _b.call(_a, "categories-layer");
  };
  return /* @__PURE__ */ jsxs(Box, { "data-testid": "b2b-footer", role: "region", "aria-label": "B2B Footer", children: [
    disabled ? null : /* @__PURE__ */ jsxs(Box, { sx: {
      display: "grid",
      gridTemplateColumns: "repeat(12, 1fr)",
      gap: "$spacing.md",
      maxWidth: "$breakpoints.xxl",
      margin: "0 auto",
      padding: "$spacing.xxl $spacing.md",
      borderTop: "1px solid $colors.borderLight",
      "@media $md_lte": {
        gap: "0"
      }
    }, children: [
      /* @__PURE__ */ jsx(Box, { sx: {
        gridColumn: "span 3",
        "@media $md_lte": {
          gridColumn: "span 12",
          marginBottom: "$spacing.md"
        }
      }, children: logo && /* @__PURE__ */ jsx(Box, { as: "img", src: logo.src, alt: logo.alt, width: logo.width, sx: {
        maxWidth: "100%"
      } }) }),
      /* @__PURE__ */ jsx(Box, { sx: {
        gridColumn: "span 9",
        display: "grid",
        gridTemplateColumns: "repeat(12, 1fr)",
        justifyItems: "center",
        flexWrap: "wrap",
        gap: "$spacing.md",
        "@media $md_lte": {
          gridColumn: "span 12",
          gap: "0",
          justifyItems: "start"
        }
      }, children: columns.map((column, index) => /* @__PURE__ */ jsx(Box, { sx: {
        gridColumn: `span ${12 / columns.length}`,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        "@media $md_lte": {
          gridColumn: "span 6",
          alignItems: "flex-start",
          marginBottom: "$spacing.md"
        },
        "@media $sm_lte": {
          gridColumn: "span 12",
          alignItems: "flex-start"
        }
      }, children: /* @__PURE__ */ jsxs(Box, { children: [
        /* @__PURE__ */ jsx(Text, { as: "h6", fontType: "h6", children: column.title }),
        /* @__PURE__ */ jsx(Text, { as: "p", fontType: "bodySmall", fontColor: "textLight", children: column.description }),
        /* @__PURE__ */ jsx(List, { appearance: "none", paddingtop: "sm", children: column.links.map((link, index2) => /* @__PURE__ */ jsx(List.Item, { children: /* @__PURE__ */ jsx(Box, { as: Anchor, href: link.url, target: link.target, rel: link.target === "_blank" ? "noopener noreferrer" : void 0, sx: {
          "&&": {
            color: "$colors.blue400",
            ":hover": {
              color: "$colors.blue500"
            }
          }
        }, children: link.title }) }, link.title + "_" + index2)) })
      ] }) }, column.title + "_" + index)) })
    ] }),
    /* @__PURE__ */ jsxs(Box, { "data-testid": "b2b-footer-legal", sx: {
      padding: "$spacing.md",
      maxWidth: "$breakpoints.xxl",
      margin: "0 auto",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      borderTop: "1px solid $colors.borderLight",
      "@media $lg_lte": {
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "$spacing.xs"
      },
      "@media $sm_lte": {
        paddingLeft: 0,
        paddingRight: 0
      }
    }, children: [
      /* @__PURE__ */ jsxs(Box, { sx: {
        display: "flex",
        gap: "$spacing.sm",
        alignItems: "stretch",
        flexWrap: "wrap",
        "@media $lg_lte": {
          flexDirection: "column",
          alignItems: "center",
          gap: "$spacing.xs"
        }
      }, children: [
        /* @__PURE__ */ jsx(Box, { sx: {
          "@media $lg_lte": {
            textAlign: "center"
          }
        }, children: /* @__PURE__ */ jsxs(Text, { fontType: "bodySmall", fontColor: "textDark", children: [
          "© ",
          /* @__PURE__ */ jsx("span", { children: (/* @__PURE__ */ new Date()).getFullYear() }),
          " ",
          "Zillow Group, Inc. and its subsidiaries. All rights reserved."
        ] }) }),
        /* @__PURE__ */ jsxs(Box, { sx: {
          display: "flex",
          gap: "$spacing.sm",
          flexWrap: "wrap",
          "@media $lg_lte": {
            justifyContent: "center"
          }
        }, children: [
          /* @__PURE__ */ jsx(TextButton, { as: "a", href: "https://www.zillow.com/corporate/zg-privacy-notice/", fontType: "bodySmall", buttonType: "secondary", children: "Privacy Notice" }),
          /* @__PURE__ */ jsx(TextButton, { as: "a", href: "https://www.zillow.com/corporate/zg-privacy-notice/#third-party", fontType: "bodySmall", buttonType: "secondary", children: "Ad Choices" }),
          /* @__PURE__ */ jsx(TextButton, { as: "a", href: "#", fontType: "bodySmall", buttonType: "secondary", className: "cookie-preference", onClick: () => showCookieConsentBanner(), children: "Cookie Preferences" })
        ] })
      ] }),
      disabled ? null : /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(ButtonGroup, { "aria-label": "Social media links", children: [
        /* @__PURE__ */ jsx(IconButton, { as: "a", icon: /* @__PURE__ */ jsx(IconFacebook, {}), title: "Facebook", size: "sm", href: "https://www.facebook.com/Zillow/", rel: "nofollow noopener noreferrer", target: "_blank", appearance: "circle", buttonType: "tertiary", bare: true }),
        /* @__PURE__ */ jsx(IconButton, { as: "a", size: "sm", title: "Instagram", icon: /* @__PURE__ */ jsx(IconInstagram, {}), href: "https://www.instagram.com/zillow/", rel: "nofollow noopener noreferrer", target: "_blank", appearance: "circle", buttonType: "tertiary", bare: true }),
        /* @__PURE__ */ jsx(IconButton, { as: "a", size: "sm", title: "LinkedIn", icon: /* @__PURE__ */ jsx(IconLinkedIn, {}), href: "https://www.linkedin.com/company/zillow/", rel: "nofollow noopener noreferrer", target: "_blank", appearance: "circle", buttonType: "tertiary", bare: true }),
        /* @__PURE__ */ jsx(IconButton, { as: "a", icon: /* @__PURE__ */ jsx(IconX, {}), title: "X", size: "sm", href: "https://x.com/zillow/", rel: "nofollow noopener noreferrer", target: "_blank", appearance: "circle", buttonType: "tertiary", bare: true })
      ] }) })
    ] })
  ] });
};
export {
  B2BFooter as default
};
